export function buildUrl(subResource?: string, action?: string) {
  let url = 'auto_updates';
  if (subResource) {
    url += `/${subResource}`;
  }

  if (action) {
    url += `/${action}`;
  }

  return url;
}
